module.exports = __webpack_public_path__ + "img/home-setting-active-4.8dd6c141.png";